export default "__VITE_ASSET__B2Q8A3JT__"